import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { TransfersHelpArticleId } from '../../../domain/transfers.domain';

@Injectable()
export class ModalTransfersHelpService {
  private readonly articleIdSubject: Subject<TransfersHelpArticleId> = new Subject<TransfersHelpArticleId>();

  getArticleIdSubject(): Subject<TransfersHelpArticleId> {
    return this.articleIdSubject;
  }

  setArticleId(articleId: TransfersHelpArticleId): void {
    if (Object.keys(TransfersHelpArticleId).indexOf(articleId.toUpperCase()) >= 0) {
      this.articleIdSubject.next(articleId);
    }
  }
}

